import axios from 'axios'

const api = axios.create({
    // baseURL: 'http://localhost:3000'
    baseURL: '  https://vercel-backend-blog.vercel.app/'
})

export default api
